// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1y0GO","inputWrap":"Table_inputWrap__3Aem1","col":"Table_col__1JApv","bmiTooltip":"Table_bmiTooltip__3_KWs"};